<template>
  <div>
    <div class="standby grid grid-cols-1" v-on:click="startSession">
      <video
        ref="video"
        class="video-player"
        muted src="@/assets/video/standby.mp4"
        poster="@/assets/video/standby.jpg"
      />
    </div>
    <div v-if="showInstruction" class="instruction md:md-instruction" v-on:click="startSession">
        Click anywhere to begin
      </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Standby',
  data() {
    return {
      showInstruction: true,
    };
  },
  methods: {
    startSession() {
      clearInterval(this.videoInterval);
      axios
        .get(`${process.env.VUE_APP_BACKEND_URL}/api/sessions/start`)
        .then((response) => {
          this.$store.commit('setSessionId', response.data.id);
          this.$refs.video.play();
          this.showInstruction = false;
        })
        .catch((error) => {
          this.$store.commit('setErrorMessage', error.toString());
        });
    },
    videoFinished() {
      this.$store.commit('setPlaySoundscape', true);
      this.$store.commit('setView', 'Intro');
    },
  },
  mounted() {
    this.$refs.video.onended = this.videoFinished;
  },
};
</script>

<style scoped>
.instruction {
  bottom: 12.5vh;
  font-size: 1rem;
  position: absolute;
  width: 100%;
}

.standby {
  height: 100vh;
}

.video-player{
  margin: auto;
  max-height: 617px;
  max-width: 90vw;
}

@responsive {
  .md-instruction {
    font-size: 1.3rem;
  }
}
</style>
